import api from './api';

export const getTennisAcademyTariffs = async (includePassive = true) => {
  return api.get('/api/tennis-academy/tariffs', { params: { includePassive } });
};

export const createTennisAcademyTariff = async (payload) => {
  return api.post('/api/tennis-academy/tariffs', payload);
};

export const updateTennisAcademyTariff = async (tariffId, payload) => {
  return api.put(`/api/tennis-academy/tariffs/${tariffId}`, payload);
};

export const deactivateTennisAcademyTariff = async (tariffId) => {
  return api.delete(`/api/tennis-academy/tariffs/${tariffId}`);
};

export const getTennisAcademyApplications = async (status) => {
  return api.get('/api/tennis-academy/applications', {
    params: { status: status && status !== 'all' ? status : undefined }
  });
};

export const updateTennisAcademyApplicationStatus = async (applicationId, payload) => {
  return api.put(`/api/tennis-academy/applications/${applicationId}/status`, payload);
};

export const getTennisAcademyPaymentHistory = async (applicationId) => {
  return api.get(`/api/tennis-academy/applications/${applicationId}/payment-history`);
};
